<template>
  <div>
    <form
      autocomplete="off"
      class="m-container-primary"
      @submit.prevent="updateProductoCuponDescuento"
    >
      <div class="row">
        <div class="column column-8">
          <AtomInputPrimary
            v-model="productoCuponDescuento.codigo"
            :input-error="$v.productoCuponDescuento.codigo.$error"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.codigo.label')"
            :message-error="messageErrorCodigo"
            name="codigo"
            :placeholder="$t('mEditionProductDiscountCodesEdit.inputs.codigo.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.codigo.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div
          v-if="false"
          class="column column-4"
        >
          <AtomSelectPrimary
            v-model.number="productoCuponDescuento.tipo_descuento"
            :elements="cuponDescuentoTipos"
            key-field="id"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.tipo_descuento.label')"
            name="tipo_descuento"
            text-field="texto"
          />
        </div>

        <div
          v-if="productoCuponDescuento.tipo_descuento == 0"
          key="descuentoPorcent"
          class="column column-8"
        >
          <AtomInputPrimary
            v-model="productoCuponDescuento.monto_descuento_0"
            :input-error="$v.productoCuponDescuento.monto_descuento_0.$error"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.monto_descuento_porcent.label')"
            :message-error="messageErrorMontoDescuento0"
            name="monto_descuento_0"
            :placeholder="$t('mEditionProductDiscountCodesEdit.inputs.monto_descuento_porcent.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.monto_descuento_0.$touch()"
          />
        </div>

        <div
          v-else
          key="descuentoFinal"
          class="column column-4"
        >
          <AtomInputPrimary
            v-model="productoCuponDescuento.monto_descuento_1"
            :input-error="$v.productoCuponDescuento.monto_descuento_1.$error"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.monto_descuento_final.label')"
            :message-error="messageErrorMontoDescuento1"
            name="monto_descuento_1"
            :placeholder="$t('mEditionProductDiscountCodesEdit.inputs.monto_descuento_final.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.monto_descuento_1.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-4">
          <AtomDatePicker
            v-model="productoCuponDescuento.fecha_inicio"
            :disabled-dates="disabledDatesStart"
            input-class="width-100-pr"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.fecha_inicio.label')"
            :message="$t('mEditionProductDiscountCodesEdit.inputs.fecha_inicio.message')"
            name="fecha_inicio"
          />
        </div>

        <div class="column column-4">
          <AtomDatePicker
            v-model="productoCuponDescuento.fecha_fin"
            :disabled="productoCuponDescuento.fecha_inicio === null || productoCuponDescuento.fecha_inicio === ''"
            :disabled-dates="disabledDatesEnd"
            input-class="width-100-pr"
            :label="$t('mEditionProductDiscountCodesEdit.inputs.fecha_fin.label')"
            :message="$t('mEditionProductDiscountCodesEdit.inputs.fecha_fin.message')"
            name="fecha_fin"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-8">
          <AtomButtonPrimary :button-primary="buttonPrimary"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { decimal, maxLength, minLength, maxValue, minValue, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductDiscountCodesEdit',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductDiscountCodesEdit.buttonPrimary'),
        class: 'a-button-products-primary margin-top-medium',
        sending: false,
        type: 'submit'
      },

      cuponDescuentoTipos: [
        {
          id: 0,
          texto: 'Aplicar descuento sobre precio final'
        },

        {
          id: 1,
          texto: 'Utilizar descuento como precio final'
        }
      ],

      disabledDatesEnd: {
        to: ''
      },

      disabledDatesStart: {
        to: ''
      },

      productoCuponDescuento: {
        codigo: '',
        id: '',
        fecha_fin: '',
        fecha_inicio: '',
        monto_descuento: '',
        monto_descuento_0: '',
        monto_descuento_1: '',
        tipo_descuento: 0
      }
    }
  },

  validations: {
    productoCuponDescuento: {
      codigo: {
        maxLength: maxLength(20),
        minLength: minLength(4),
        required
      },

      monto_descuento_0: {
        decimal,
        maxValue: maxValue(100),
        minValue: minValue(0.01),
        required
      },

      monto_descuento_1: {
        decimal,
        minValue: minValue(0.01),
        required
      }
    }
  },

  computed: {
    messageErrorCodigo () {
      return this.$validation.getValidationMessage('mEditionProductDiscountCodesEdit', this.$v.productoCuponDescuento.codigo, 'codigo')
    },

    messageErrorMontoDescuento0 () {
      return this.$validation.getValidationMessage('mEditionProductDiscountCodesEdit', this.$v.productoCuponDescuento.monto_descuento_0, 'monto_descuento_0')
    },

    messageErrorMontoDescuento1 () {
      return this.$validation.getValidationMessage('mEditionProductDiscountCodesEdit', this.$v.productoCuponDescuento.monto_descuento_1, 'monto_descuento_1')
    }
  },

  watch: {
    'productoCuponDescuento.fecha_inicio': {
      handler () {
        if (this.productoCuponDescuento.fecha_inicio === '' || this.productoCuponDescuento.fecha_inicio === null ||
          this.$moment(this.productoCuponDescuento.fecha_inicio).isAfter(this.productoCuponDescuento.fecha_fin)) {
          this.productoCuponDescuento.fecha_fin = null
        }

        this.disabledDatesEnd = {
          to: this.productoCuponDescuento.fecha_inicio
        }
      },

      inmediate: true
    }
  },

  created () {
    this.$router.push({ name: 'notFound' })
    if (Object.keys(this.$store.getters.getProductSelectedDiscount).length === 0) {
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}`)
    } else {
      this.productoCuponDescuento = Object.assign({}, this.$store.getters.getProductSelectedDiscount)
      this.setMontoDescuento(this.productoCuponDescuento.monto_descuento)
    }
  },

  mounted () {
    this.disabledDatesStart = {
      to: this.$moment().subtract(1, 'days')
    }

    this.productoCuponDescuento.fecha_fin = this.productoCuponDescuento.fecha_fin !== undefined
      ? this.$moment.parseZone(this.productoCuponDescuento.fecha_fin).format('YYYY-MM-DD')
      : ''

    this.productoCuponDescuento.fecha_inicio = this.productoCuponDescuento.fecha_inicio !== undefined
      ? this.$moment.parseZone(this.productoCuponDescuento.fecha_inicio).format('YYYY-MM-DD')
      : ''
  },

  methods: {
    updateProductoCuponDescuento () {
      console.log('acción deshabilitada momentaneamente')
    },

    updateProductoCuponDescuentoDeshabilitado () {
      this.validarMontoDescuento()
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('producto', 'updateProductoCuponDescuento', this.productoCuponDescuento, [this.$route.params.id, this.productoCuponDescuento.id])
          .then(response => {
            this.$alerts.pushAlert('mEditionProductDiscountCodesEdit', 'updateProductoCuponDescuento', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}`)
            this.buttonPrimary.sending = false
            this.resetMontoDescuento()
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductDiscountCodesEdit', 'updateProductoCuponDescuento', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
            this.resetMontoDescuento()
          })
      } else {
        this.resetMontoDescuento()
      }
    },

    resetMontoDescuento () {
      if (this.productoCuponDescuento.tipo_descuento === 0) {
        this.productoCuponDescuento.monto_descuento_1 = ''
      } else {
        this.productoCuponDescuento.monto_descuento_0 = ''
      }
    },

    setMontoDescuento (montoDescuento) {
      if (this.productoCuponDescuento.tipo_descuento === 0) {
        this.productoCuponDescuento.monto_descuento_0 = montoDescuento
        this.productoCuponDescuento.monto_descuento_1 = ''
      } else {
        this.productoCuponDescuento.monto_descuento_0 = ''
        this.productoCuponDescuento.monto_descuento_1 = montoDescuento
      }
    },

    validarMontoDescuento () {
      if (this.productoCuponDescuento.tipo_descuento === 0) {
        this.productoCuponDescuento.monto_descuento = this.productoCuponDescuento.monto_descuento_0
        this.productoCuponDescuento.monto_descuento_1 = 0.01
      } else {
        this.productoCuponDescuento.monto_descuento = this.productoCuponDescuento.monto_descuento_1
        this.productoCuponDescuento.monto_descuento_0 = 0.01
      }
    }
  }
}
</script>
